// 判断是否是微信环境
import Vue from 'vue'
import { isWx } from '../../utils/ua'

export default (router) => {
    router.beforeEach((to, from, next) => {
        Vue.$store.dispatch('checkIsWeixin', isWx())
        next()
    })
}
